class SassProduct extends HTMLElement {
  constructor(el) {
    super(el);
    this.setupDefaults();
    this.addListeners();
  }

  setupDefaults() {
    this.jsonData = JSON.parse(this.querySelector("[data-product-json]").text);
    this.includes = this.querySelector(".includes-section li");
    this.price = this.querySelector(".price-value");
    this.image = this.querySelector(".product-wrap-image");
    this.title = this.querySelector(".item-header");
    this.swatch = this.querySelectorAll('.sass-item__option [type="radio"]');
    this.paywhirl = this.querySelector(".sass-item__paywhirl");
    this.options = {
      option1: null,
      option2: null,
      option3: null,
    };

    this.currentVariant = null;

    this.swatch.forEach((item) =>
      item.addEventListener("change", (e) => this.onOptionChanged(e))
    );

    this.jsonData.product.variants.forEach((variant) => {
      if (variant["id"] === this.jsonData["selected_variant_id"]) {
        this.currentVariant = variant;
        this.options.option1 = variant["option1"];
        this.options.option2 = variant["option2"];
        this.options.option3 = variant["option3"];
      }
    });
  }

  addListeners() {
    // this.addEventListener('variant:changed', (e, data) => this.onVariantChanged(e, data));
    this.addEventListener("click", (e) => this.onProductSelected(e));
  }

  onProductSelected(e) {
    // e.preventDefault();
    const $target = e.currentTarget;
    const $parent = $target.closest(".sass__listing");
    $parent
      .querySelectorAll(".sass-item")
      .forEach((element) => element.classList.remove("checked"));
    $target.classList.add("checked");
    window.dispatchEvent(
      new CustomEvent("onProductSelected", {
        detail: {
          title: $target.querySelector(".page-sass__product-header-label")
            .innerHTML,
          price: $target.querySelector(".sass__product-price").innerHTML,
          image: this.jsonData.product.featured_image,
        },
      })
    );
  }

  onOptionChanged(e) {
    this.options[
      "option" + e.currentTarget.getAttribute("data-option-position")
    ] = e.currentTarget.value;
    this.currentVariant = this.getCurrentVariantFromOptions();
    this.dataset.productId = this.currentVariant.id;
  }

  getCurrentVariantFromOptions() {
    var found = false;
    this.jsonData.product.variants.forEach((variant) => {
      if (
        variant["option1"] === this.options.option1 &&
        variant["option2"] === this.options.option2 &&
        variant["option3"] === this.options.option3
      ) {
        found = variant;
      }
    });

    return found || null;
  }
}

customElements.define("sass-product", SassProduct);
